"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    root: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    icon: {
        fontSize: 188,
        marginBottom: 10,
        color: theme.palette.text.secondary
    },
    title: {
        textAlign: 'center',
        color: theme.palette.text.secondary
    }
});
exports.default = styles;
//# sourceMappingURL=NoResultsFoundStyle.js.map